import { render, staticRenderFns } from "./Christmas_drinkItem.vue?vue&type=template&id=17708c4c&scoped=true"
import script from "./Christmas_drinkItem.vue?vue&type=script&lang=ts"
export * from "./Christmas_drinkItem.vue?vue&type=script&lang=ts"
import style0 from "./Christmas_drinkItem.vue?vue&type=style&index=0&id=17708c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17708c4c",
  null
  
)

export default component.exports